import type { AxiosRequestConfig } from "axios";

export type TContentType =
	| "text/html"
	| "text/plain"
	| "multipart/form-data"
	| "application/json"
	| "application/x-www-form-urlencoded"
	| "application/octet-stream";

export interface IRequestConfig extends AxiosRequestConfig {
	token: string | null;
	contentType?: TContentType;
}

export const formatRequestConfig = (config: IRequestConfig | undefined) => {
	if (!config) {
		return undefined;
	}

	const { token, ...rest } = config;

	return {
		...rest,
		headers: {
			"Content-Type": config?.contentType || "application/json",
			...(token ? { "X-AUTH-TOKEN": token } : null),
			...rest.headers,
		},
	};
};
